import * as scmpAccount from "@product/scmp-account-sdk";
import { useMountEffect } from "@react-hookz/web";
import React, { useCallback, useMemo } from "react";
import { CloseButton } from "~/components/acquisition-popup-container/display/popups/common/close-button";
import { PopupBackdrop } from "~/components/acquisition-popup-container/display/styles";
import { useSdkContext } from "~/components/contexts";
import { Modal } from "~/components/modal";
import { getIsInWebView } from "~/lib/utils";
import { getDestinationString } from "./actions";
import { AccountSignUpContainer, Container, ContentContainer, IconContainer, IntroductionContainer, IntroductionHTML, IntroductionLine, IntroductionNumber, OtherSignUpMethodMessage, StyledBookmark, StyledComment, StyledPlus, StyledScmpLogo, StyledStar, Title } from "./styles";
export const WhyRegisterPopup = ({
  modalContainerReference,
  onClose,
  whyRegister
}) => {
  const introductions = whyRegister.content.introductions;

  // Note Introduction is an object which means the order may not be guaranteed and it uses 1,
  //      2,3 as keys so have added a.sort. Based on post below, the order
  //      should be fine without it
  //      https://stackoverflow.com/questions/5525795/does-javascript-guarantee-object-property-order/38218582#38218582
  const sortedIntroductionKeys = Object.keys(introductions).sort((a, b) => a.localeCompare(b));
  const {
    config,
    handleOpenLoginDialog,
    handleTrackGA4
  } = useSdkContext();
  const destinationString = useMemo(() => getDestinationString(whyRegister.trackingActionName), [whyRegister.trackingActionName]);
  const reference = useCallback(container => {
    if (!container) return;
    const accountUrl = new URL(config.accounts.host);
    scmpAccount.init({
      AUTH_CALLBACK_URL: `${config.accounts.authCallbackUrl}`,
      DEBUG_LOG: false,
      DESTINATION: destinationString,
      MIXPANEL_TOKEN: `${config.mixpanel.token}`,
      RECAPTCHA_CONTAINER_ID: "",
      RECAPTCHA_SITE_KEY: `${config.recaptcha.siteKey}`,
      REGISTER_CALLBACK_URL: `${config.accounts.registerCallbackUrl}`,
      SCMP_ACCOUNT_HOST: accountUrl.host,
      SCMP_ACCOUNT_PROTOCOL: accountUrl.protocol.slice(0, -1)
    });
    const isInWebView = getIsInWebView();
    scmpAccount.initLoginWidget(container.id, {
      destination: destinationString,
      loginDescription: "",
      loginWithEmail: false,
      sendWelcomeEmail: false,
      thirdPartySignInOptions: {
        triggerPoint: "ppto",
        withGoogle: !isInWebView
      },
      title: ""
    });
  }, [config.accounts.authCallbackUrl, config.accounts.host, config.accounts.registerCallbackUrl, config.mixpanel.token, config.recaptcha.siteKey, destinationString]);
  const campaignName = whyRegister.trackingActionName;
  useMountEffect(() => {
    handleTrackGA4({
      action: "imp",
      category: "promopopup",
      customized_parameters: {
        cta_type: "login_register",
        internal_campaign: campaignName,
        step: "1"
      },
      subcategory: ""
    });
  });
  const handleGoogleSignUpClick = () => {
    handleTrackGA4({
      action: "click",
      category: "promopopup",
      customized_parameters: {
        cta_type: "login_register",
        internal_campaign: campaignName,
        message: "Sign in with Google",
        step: "1"
      },
      subcategory: ""
    });
  };
  const handleOtherMethodSignUp = () => {
    handleTrackGA4({
      action: "click",
      category: "promopopup",
      customized_parameters: {
        cta_type: "login_register",
        internal_campaign: campaignName,
        message: "Sign in with other methods",
        step: "1"
      },
      subcategory: ""
    });
    onClose();
    handleOpenLoginDialog({
      destination: destinationString,
      ga4CustomParameter: {
        internal_campaign: campaignName,
        trigger_point: "ppto"
      }
    });
  };
  const handleCloseModal = () => {
    handleTrackGA4({
      action: "click",
      category: "promopopup",
      customized_parameters: {
        cta_type: "login_register",
        internal_campaign: campaignName,
        message: "close button",
        step: "1"
      },
      subcategory: ""
    });
    onClose();
  };
  return /*#__PURE__*/React.createElement(Modal, {
    BackdropComponent: PopupBackdrop,
    container: modalContainerReference === null || modalContainerReference === void 0 ? void 0 : modalContainerReference.current,
    fadeTimeout: 400,
    open: true,
    "data-qa": "why-register-popup"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(CloseButton, {
    onClose: handleCloseModal
  }), /*#__PURE__*/React.createElement(ContentContainer, null, /*#__PURE__*/React.createElement(StyledScmpLogo, null), /*#__PURE__*/React.createElement(Title, {
    dangerouslySetInnerHTML: {
      __html: whyRegister.content.title
    }
  }), /*#__PURE__*/React.createElement(IconContainer, null, /*#__PURE__*/React.createElement(StyledPlus, null), /*#__PURE__*/React.createElement(StyledBookmark, null), /*#__PURE__*/React.createElement(StyledComment, null), /*#__PURE__*/React.createElement(StyledStar, null)), /*#__PURE__*/React.createElement(IntroductionContainer, null, sortedIntroductionKeys.map(key => /*#__PURE__*/React.createElement(IntroductionLine, {
    key: key
  }, /*#__PURE__*/React.createElement(IntroductionNumber, null, `${key}. `), /*#__PURE__*/React.createElement(IntroductionHTML, {
    dangerouslySetInnerHTML: {
      __html: introductions[key]
    }
  })))), /*#__PURE__*/React.createElement(AccountSignUpContainer, {
    id: "social-login-widget",
    ref: reference,
    onClick: handleGoogleSignUpClick
  }), /*#__PURE__*/React.createElement(OtherSignUpMethodMessage, {
    onClick: handleOtherMethodSignUp
  }, "Sign in with other methods"))));
};
WhyRegisterPopup.displayName = "WhyRegisterPopup";